import h from 'snabbdom/h';
import { filter, map, reduce } from 'ramda';
import * as svgIcons from './icons';
import { getActiveColor, getCanvasElement, getHoverColor, } from '../modules/player';
import { getCommands, isCommandActive, runCommand, } from '../modules/commands';
import timeline from './timeline';

const isTouch = __BROWSER__ && (!!('ontouchstart' in window) || window.navigator.msMaxTouchPoints > 0);

export function hoverStyle(store) {
  const hoverColor = getHoverColor(store);

  const hoverStyle = isTouch ? '' : `
div.claraplayer ul.tools li:not(.active):hover svg path {
  fill: ${hoverColor};
}
`;
  return h('style', { props: { innerHTML: hoverStyle } });
}

export default function manipulatorTools(store) {
  const tools = getCommands(store, 'playerTools');
  const activeColor = getActiveColor(store);

  function click(what) {
    return (ev) => {
      store.dispatch(runCommand(what));
      const canvas = getCanvasElement(store);
      if (canvas) canvas.focus();
    };
  }

  let toolChildren = [
    hoverStyle(store),

    h('ul.tools', { style: {
      position: 'relative',
      bottom: 0,
      left: 0,
      listStyleType: 'none',
      padding: '0 5px',
      margin: 0,
      zIndex: 2147483647,
    }, }, [svgIcons.glowFilter()].concat(map((key) => {
      const command = tools[key];
      const active = command.isActive ? command.isActive(store) : command.active;
      const label = command.active && command.activeLabel ? command.activeLabel : command.label;
      const svgIcon = svgIcons[command.options.icon || key];
      const iconChildren = [];

      if (typeof svgIcon === 'function') {
        iconChildren.push(svgIcon({ width: 34, height: 34, title: label }, { active, activeColor }));
      }  else {
        iconChildren.push(h('span', { style: { color: active ? activeColor : '#fff' } }, label));
      }

      return h('li' + (active ? '.active' : ''), {
        attrs: { title: label },
        on: { click: click(key) },
        style: {
          cursor: 'pointer',
          float: 'left',
          borderRadius: '5px',
          padding: '5px',
          boxSizing: 'border-box',
        },
      }, iconChildren);
    }, Object.keys(tools)))),
  ];

  const tLine = timeline(store);
  if (tLine) toolChildren.push(tLine);

  return h('span', { style: {
    position: 'absolute',
    left: '5px',
    right: '5px',
    bottom: '5px',
    display: 'flex',
    flexWrap: 'nowrap',
    height: '54px',
  }, }, toolChildren);
};



// WEBPACK FOOTER //
// ./src/components/manipulatorTools.js